import { render, staticRenderFns } from "./PortalInviteList.vue?vue&type=template&id=e20f04b0&scoped=true&"
import script from "./PortalInviteList.vue?vue&type=script&lang=js&"
export * from "./PortalInviteList.vue?vue&type=script&lang=js&"
import style0 from "./PortalInviteList.vue?vue&type=style&index=0&id=e20f04b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20f04b0",
  null
  
)

export default component.exports